import { render, staticRenderFns } from "./shoppingModelUpdate.vue?vue&type=template&id=406dd382&scoped=true&"
import script from "./shoppingModelUpdate.vue?vue&type=script&lang=js&"
export * from "./shoppingModelUpdate.vue?vue&type=script&lang=js&"
import style0 from "./shoppingModelUpdate.vue?vue&type=style&index=0&id=406dd382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406dd382",
  null
  
)

export default component.exports